import React from "react";
import { useDispatch, useSelector } from "react-redux";
import PropTypes from "prop-types";

import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material";

import { requestPasswordResetLink} from "../../actions/accountActions";
import { getUser } from "../../reducers";


export const PasswordDialog = ({open, onSave, onClose}) => (
    <Dialog open={open} onClose={onClose} fullWidth>
        <DialogTitle>Change password</DialogTitle>
        <DialogContent>
            Request password reset email?
            <DialogContentText>
                To reset your password, we'll send you a recovery link. Please check your email and follow the instructions to set a new password.
            </DialogContentText>
        </DialogContent>
        <DialogActions>
            <Button key="cancel" onClick={onClose}>Cancel</Button>
            <Button key="save" variant="contained" color="primary" onClick={() => {onSave(); onClose();}}>
                Send
            </Button>
        </DialogActions>
    </Dialog>
);

const PasswordDialogContainer = ({open, onClose, ...others}) => {
    const dispatch = useDispatch();
    const { email } = useSelector(getUser);
    const handleSubmit = () => dispatch(requestPasswordResetLink(email));

    return (
        <PasswordDialog
            open={open}
            onClose={onClose}
            onSave={handleSubmit}
            {...others}
        />
    );
};

PasswordDialogContainer.propTypes = {
    open: PropTypes.bool,
    onClose: PropTypes.func
};

PasswordDialogContainer.defaultProps = {
    open: false,
    onClose: () => {},
};

export default PasswordDialogContainer;
